import { useState, useEffect } from "react";
import { Modal, Text, Flex, Button, Stack, Box } from "@mantine/core";
import trpc from "@/shared/utils/trpc";

interface AcceptInterestModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

export default function AcceptInterestModal({
  opened,
  onClose,
  onConfirm,
  isLoading = false,
}: AcceptInterestModalProps) {
  const [engagementFeeCredits, setEngagementFeeCredits] = useState(14);

  useEffect(() => {
    if (opened) {
      trpc.paymentConfig.get.query().then((config) => {
        setEngagementFeeCredits(config.engagementFeeCredits);
      });
    }
  }, [opened]);

  return (
    <Modal opened={opened} onClose={onClose} title="Accept Interest Request" centered size="md">
      <Stack gap="md">
        <Text fz="sm" c="slate.5">
          You're about to accept an interest request from:
        </Text>

        <Box
          p="md"
          style={{
            border: "1px solid #2563EB33",
            backgroundColor: "#2563EB0D",
            borderRadius: "md",
          }}
        >
          <Text fz="sm" mb="xs">
            This will:
          </Text>
          <Stack gap={4}>
            <Text fz="sm">• Create a mutual match</Text>
            <Text fz="sm">• Require collaboration payment ({engagementFeeCredits} Credits)</Text>
            <Text fz="sm">• Unlock full company details</Text>
            <Text fz="sm">• Activate workspace</Text>
          </Stack>
        </Box>

        <Flex justify="flex-end">
          <Button onClick={onConfirm} loading={isLoading}>
            Confirm & Proceed
          </Button>
        </Flex>
      </Stack>
    </Modal>
  );
}
